/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import Select from 'react-select';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import RevenueByCustomerChart from './RevenueByCustomerChart';
import { sortByOptions } from '../../helper'

const RevenueByCustomerShow = ({ dir, data, viewReportButton, title, selectedYear }) => {

    const [selectedOptions, setSelectedOptions] = useState([])
    const [sortBySelected, setSortBySelected] = useState(sortByOptions[1])

    const changeFilter = (value) => {
        setSelectedOptions(value)
    };

    const customerWiseData = {}; 

    let dataToPlot = []
    data.forEach((item) => {   
        if (item && customerWiseData[item.customerName]) {
            customerWiseData[item.customerName].push(item)
        } else {
            customerWiseData[item.customerName] = [item]
        }
                
    })
   
    const currentCustomer = Object.keys(customerWiseData);
    const options = [];

    for (let i = 0; i < currentCustomer.length; i += 1) {
        const cust = currentCustomer[i];
        const currentData = customerWiseData?.[cust] ?? [];

        let currentMonthMax = 0;
       const custType = currentData?.reduce((acc, item) => item.type, 0)

        const totalJan = currentData?.reduce((acc, item) => acc + Number(item.jan), 0)
        const totalFeb = currentData?.reduce((acc, item) => acc + Number(item.feb), 0)
        const totalMar = currentData?.reduce((acc, item) => acc + Number(item.mar), 0)
        const totalApr = currentData?.reduce((acc, item) => acc + Number(item.apr), 0)
        const totalMay = currentData?.reduce((acc, item) => acc + Number(item.may), 0)
        const totalJun = currentData?.reduce((acc, item) => acc + Number(item.jun), 0)
        const totalJul = currentData?.reduce((acc, item) => acc + Number(item.jul), 0)
        const totalAug = currentData?.reduce((acc, item) => acc + Number(item.aug), 0)
        const totalSep = currentData?.reduce((acc, item) => acc + Number(item.sept), 0)
        const totalOct = currentData?.reduce((acc, item) => acc + Number(item.oct), 0)
        const totalNov = currentData?.reduce((acc, item) => acc + Number(item.nov), 0)
        const totalDec = currentData?.reduce((acc, item) => acc + Number(item.dec), 0)

        // currentMonthMax = totalJan + totalFeb + totalMar + totalApr + totalMay + totalJun
        // + totalJul + totalAug + totalSep + totalOct + totalNov + totalDec
        const monthWiseAmountTotal = [];
        monthWiseAmountTotal.push({
            "day": `Jan - ${selectedYear}`,            
            'Amount': Number(totalJan),            
        },
        {
            "day": `Feb - ${selectedYear}`,            
            'Amount': Number(totalFeb),            
        },
        {
            "day": `Mar - ${selectedYear}`,            
            'Amount': Number(totalMar),            
        },
        {
            "day": `Apr - ${selectedYear}`,            
            'Amount': Number(totalApr),            
        },
        {
            "day": `May - ${selectedYear}`,            
            'Amount': Number(totalMay),            
        },
        {
            "day": `Jun - ${selectedYear}`,            
            'Amount': Number(totalJun),            
        },
        {
            "day": `Jul - ${selectedYear}`,            
            'Amount': Number(totalJul),            
        },
        {
            "day": `Aug - ${selectedYear}`,            
            'Amount': Number(totalAug),            
        },
        {
            "day": `Sep - ${selectedYear}`,            
            'Amount': Number(totalSep),            
        },
        {
            "day": `Oct - ${selectedYear}`,            
            'Amount': Number(totalOct),            
        },
        {
            "day": `Nov - ${selectedYear}`,            
            'Amount': Number(totalNov),            
        },
        {
            "day": `Dec - ${selectedYear}`,            
            'Amount': Number(totalDec),            
        })      
        currentMonthMax = Math.max(totalJan,totalFeb,totalMar,totalApr,totalMay,totalJun
        ,totalJul,totalAug,totalSep,totalOct,totalNov,totalDec)
        options.push({
            // value: cust, label: cust
            value: `${cust} ( ${custType} )`, label: `${cust} ( ${custType} )`
        })
        dataToPlot.push({
            // title: cust,
            title: `${cust} ( ${custType} )`,
            monthWiseAmountTotal,
            currentYearMonthMax: currentMonthMax > 0 ? currentMonthMax : 0
          })
    }
    
    if (selectedOptions?.length) {
        const selected = selectedOptions?.reduce((acc, item) => {
            acc[item?.value] = item.value
            return acc
        }, {})
        console.log(selected)
        console.log(dataToPlot)
        dataToPlot = dataToPlot.filter(item => selected[item.title])
    }

    const sortBy = sortBySelected?.value;

    if (sortBy === 'title') {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy]?.toLowerCase() > b?.[sortBy]?.toLowerCase() ? 1 : -1)
    } else {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy] < b?.[sortBy] ? 1 : -1)
    }
    
    return (
        <Col xs="12">
            <Card className="pb-3 show-categ-daily-sales">
                <div className="card__title row " style={{ position: 'relative' }} >
                <h5 className="bold-text col-md-5">{title}</h5>
                <div className="form__form-group mb-0 col-md-6">
                    <div className="row justify-content-center align-items-center" id='dvChartFilter'>
                        <div className="col-6">
                            <span className="form__form-group-label font-weight-bold">
                                Select Customer</span>
                            <div className="form__form-group-field">
                                <Select
                                    value={selectedOptions}
                                    options={options}
                                    clearable={false}
                                    placeholder='Select Customer'
                                    className="select_filter-200"
                                    onChange={changeFilter}
                                    classNamePrefix="react-select"
                                    isMulti

                                />
                            </div>
                        </div>                        
                        <div className="col-4">
                            <span className="form__form-group-label font-weight-bold">Sort By</span>
                            <div className="form__form-group-field">
                                <Select
                                    value={sortBySelected}
                                    options={sortByOptions}
                                    clearable={false}
                                    placeholder="Sort By"
                                    className="select_filter-110"
                                    onChange={setSortBySelected}
                                    classNamePrefix="react-select"
                                />
                            </div>

                        </div>
                    </div>
                </div>
                <div className="col-1" id='dvChartView'>
                    {viewReportButton?.()}
                </div>
                </div>

                {dataToPlot.length ? dataToPlot?.map((customer, index) => (<Row key={customer.title}>
                <Col sm={4} md={2}><CardText>{customer.title}</CardText></Col>
                <Col sm={8} md={10}>
                    <RevenueByCustomerChart
                        dataToPlot={customer.monthWiseAmountTotal}
                        height={400}
                        showTitle={false}
                        dir={dir}
                    />

            </Col>
            </Row>
            )) : <div className="no-data">No data to display</div>}
            </Card>
        </Col>

    )
}

RevenueByCustomerShow.propTypes = {
    dir: PropTypes.string.isRequired,
    data: PropTypes.arrayOf({}).isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
    selectedYear: PropTypes.object.isRequired,
};

RevenueByCustomerShow.defaultProps = {
    title: 'Revenue By Customer',
}

export default RevenueByCustomerShow;
